export default {
  'CUT': 'c',
  'EXTRUDE': 'e',
  'PLANE': 'p',
  'BOX': 'b',
  'ZoomIn': '=',
  'ZoomOut': '-',
  'LookAtFace': '0',
  'CycleFacesNext': ']',
  'CycleFacesPrev': '[',
  'ToggleCameraMode': '/',
  'StandardViewFront': '1',
  'StandardViewBack': '2',
  'StandardViewLeft': '3',
  'StandardViewRight': '4',
  'StandardViewTop': '5',
  'StandardViewBottom': '6',
  'StandardView3Way': '7',
  'StandardView3WayBack': '8',
  'HistoryBackward': ',',
  'HistoryForward': '.',
  'EditFace': 's',
  'DeselectAll': 'ctrl+d',
  'menu.craft': 'shift+c',
  'menu.primitives': 'shift+a',
  'menu.main': 'space',
  'Save': 'ctrl+s',
  'ImagePngExport': 'shift+3',
  'Info': 'F1',
  'DebugOpenBrepDebugger': 'ctrl+b'
}; 
